import { Component, Output, EventEmitter } from '@angular/core';

import { ReservationService } from './../../services';
import { ReservationModel } from './../../models';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';

import { EventsService } from './../../services';

import { CustomDateFormatter } from './custom-formatter.provider';

import {
    CalendarEvent,
    CalendarEventAction,
    CalendarEventTimesChangedEvent,
    CalendarDateFormatter 
} from 'angular-calendar';

@Component({
    selector: 'app-calendar',
    templateUrl: './app-calendar.component.html',
    styleUrls: ['./app-calendar.component.scss'],
    providers: [
        {
            provide: CalendarDateFormatter,
            useClass: CustomDateFormatter
        }
    ]
})

export class AppCalendarComponent {    

    viewDate = new Date;
    reservations: ReservationModel[];
    reservation: ReservationModel;
    events: CalendarEvent[];
    view: string = "week";
    
    refresh: Subject<any> = new Subject();

    constructor(private reservationService: ReservationService,
                private eventsService: EventsService) {
    }

    ngOnInit(): void {
        this.getEvents();
        this.refreshSubscribe();
    }

    getEvents() {
        this.reservationService.getAll().subscribe(res => {
            if (res) {
                this.reservations = res;
                this.setData();
            }
        })
    }

    setData() {
        var list: CalendarEvent[] = [];
        for (let reservation of this.reservations) {
            var tempReservation: CalendarEvent = {
                start: new Date(reservation.start),
                end: new Date(reservation.end),
                title: reservation.title,
                color: { primary: '#1e90ff', secondary: '#D1E8FF' },
                draggable: true,
                resizable: { beforeStart: true, afterEnd: true },
                meta: {
                    id: reservation.id
                }
            }
            list.push(tempReservation);
        }
        
        this.events = list;
    }

    addReservationEvent() {
        if (this.view == "day") {
            this.eventsService.addReservation(this.viewDate);
        } else {
            this.eventsService.addReservation();
        }
    }

    dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
        this.viewDate = date;
        this.view = "day";        
    }

    eventClicked(event: CalendarEvent) {
        this.eventsService.eventTimeAction(event);
    }

    hourSegmentClicked(date: Date) {        
        this.eventsService.hourClicked(date);
    }

    eventTimesChanged({
        event,
        newStart,
        newEnd
      }: CalendarEventTimesChangedEvent): void {
        event.start = newStart;
        event.end = newEnd;
        
        this.eventsService.eventTimeAction(event);
        this.refresh.next();
      }

    refreshSubscribe() {
        this.eventsService.refreshCalEmitter.subscribe(res => {
            this.getEvents();
        })
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-calendar/app-calendar.component.ts